import { PlayerMouseWheelScrollSensitivity } from '../enums/playerMouseWheelScrollSensitivity'
import type { SupportTicketType } from '../enums/supportTicketType'
import type { JsonHttpRequestOptions } from '../interfaces/JsonHttpRequestOptions'
import type { UserPlayerPreferences } from '../interfaces/UserPlayerPreferences.ts'
import Http from '../utils/http'

interface PatchPlayerPreferencesParams extends Record<
    string,
    string | string[] | number | boolean | null | undefined
> {
    side_menu_shortcut?: string[]
    usb_agent_port?: number
    mousewheel_scroll_sensitivity?: PlayerMouseWheelScrollSensitivity
    stream_bitrate_mbps?: number
    is_fullscreen_mode_enabled?: boolean
    is_upscale_mode_enabled?: boolean
    is_fps_optimization_enabled?: boolean
    is_metrics_panel_displayed?: boolean
    is_metrics_panel_folded?: boolean
    is_auto_disconnect_enabled?: boolean
}

interface SendSupportRequestParams extends Record<
    string,
    string | number | boolean | null | undefined
> {
    type: SupportTicketType | string
    description: string
    proxmox_machine_id: number
    proxmox_machine_name: string
    proxmox_machine_operating_system: string
    proxmox_streaming_token: string | null
    is_cursor_in_captured_mode: boolean
    browser_operating_system: string
    browser_name: string
    browser_version: string
    is_browser_mobile: boolean
}

const patchPlayerPreferences = (
    params: PatchPlayerPreferencesParams,
    options?: JsonHttpRequestOptions
): Promise<{ data: UserPlayerPreferences }> => {
    return Http.patchJson<{ data: UserPlayerPreferences }>(
        `/api/users/player-preferences`,
        params,
        options
    )
}

const keepSessionAlive = (
    options: JsonHttpRequestOptions = { displayToastOnError: false }
): Promise<{}> => {
    return Http.putJson<{}>(`/api/users/sessions/keep-alive`, {}, options)
}

const sendSupportRequest = (
    params: SendSupportRequestParams,
    options: JsonHttpRequestOptions = { displayToastOnError: false }
): Promise<{}> => {
    return Http.postJson<{}>(`/api/users/support-tickets`, params, options)
}

export default { patchPlayerPreferences, keepSessionAlive, sendSupportRequest }
